import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Helmet } from 'react-helmet';
import { useIntl } from 'react-intl';
import Notice from '../Notice';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import Icon, { IconSizes } from '../Icon';
import styles from './LoginAuthorized.module.scss';
function LoginAuthorized() {
    var intl = useIntl();
    return /*#__PURE__*/ _jsxs(React.Fragment, {
        children: [
            /*#__PURE__*/ _jsx(Helmet, {
                title: intl.formatMessage({
                    id: "NAepnj",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Authorized"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Notice, {
                beforeElement: /*#__PURE__*/ _jsx(Icon, {
                    icon: faCheckCircle,
                    size: IconSizes.LG,
                    className: styles.loginAuthorizedIcon
                }),
                heading: intl.formatMessage({
                    id: "O7D5/V",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Login Authorized"
                        }
                    ]
                }),
                description: intl.formatMessage({
                    id: "5LJhPK",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "You can now close this window."
                        }
                    ]
                })
            })
        ]
    });
}
export default LoginAuthorized;
